import { MapPin } from 'lucide-react'
import { useMemo, useState } from 'react'

import FilterManagementDropdown from '../../brokers/needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../../brokers/needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../../brokers/types'
import { USStates } from '../../reusable/form/StateDropdown'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'

const StateFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const stateOptions: ComboboxFilterOption<string>[] = useMemo(() =>
    USStates
      .filter(state => state.value !== '') // Remove the "Select a state" option
      .map(state => ({
        label: `${state.label} (${state.value})`, // Full state name with abbreviation (e.g., "California (CA)")
        value: state.value, // State abbreviation (e.g., "CA")
      }))
      .sort((a, b) => a.label.localeCompare(b.label)), []
  )

  const filteredOptions = stateOptions.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'States', options: filteredOptions }]}
        placeholder='Search states to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={stateOptions}
          noSelectionText='State'
          pluralIdentifier='states'
        >
          <MapPin size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default StateFilter
